'use client';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';

var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
function NoSsr(_ref) {
  var children = _ref.children;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mountedState = _React$useState2[0],
    setMountedState = _React$useState2[1];
  useEnhancedEffect(function () {
    setMountedState(true);
  }, []);
  if (!mountedState) {
    // When window isn't present render null
    return null;
  }
  return children;
}

export { NoSsr as default };
